module.exports = __webpack_public_path__ + "officialStatic/img/gw-detailList3.6182da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/gw-detailList3.png
// module id = elw8
// module chunks = 0